import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'initialLetter',
  pure: false,
  standalone: true,
})
export class InitialLetterPipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);

  transform(description: string): string {
    const labelTranslation = this.translateService.instant(description);

    let labelInitial = null;

    if (Array.from(labelTranslation).length) {
      labelInitial = Array.from(labelTranslation)[0] as string;
    }

    return labelInitial?.toLowerCase();
  }
}
